/* eslint-disable react-hooks/exhaustive-deps */
import { Divider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { FC, useState, useEffect, useMemo } from "react";
import { Conta } from "src/components/contas/contas/types";
import { Cidade, Estado } from "src/components/geral/RegioesDataTable/types";
import { AnexosVerticais } from "src/components/projetos/AnexosVerticais";
import { GrupoEstrutura } from "src/components/projetos/types";
import { ListUtil } from "src/framework/commons/ListUtil";
import { ValidateUtil } from "src/framework/commons/ValidateUtil";
import { FullWidthButton } from "src/framework/components/buttons/FullWidthButton";
import { BottomBar } from "src/framework/components/commons/BottomBar";
import { InputSelectSimple } from "src/framework/components/forms/inputs/InputSelectSimple";
import { InputSwitch } from "src/framework/components/forms/inputs/InputSwitch";
import { TabContent } from "src/framework/components/navigations/tabs/TabContent";
import { TabControl } from "src/framework/components/navigations/tabs/TabControl";
import api, { apiNoLoading, IDataRequest, IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import { notifierStore } from "src/framework/store/NotifierStore";
import { useObservable } from "src/framework/store/storeUtil";
import { BaseFormProperties } from "src/framework/types";
import { ProjetosProvider } from "src/providers/ProjetosProvider";
import { cidades$, componentes$, estados$, getAnalistasEngenharia, getCidades, getDistribuidores, getEstados, getEvs, getRevendas, grupoEstrutura$, limitacoes$ } from "src/store/global.store";
import { Anexo, ComponenteProjeto, DEFAULT_VERTICAIS, Desconto, Disposicao, ProjetoCalcular, SITUACAO, Verticais, VerticaisExtra } from "../types";
import { TAB_COMPONENTES, TAB_DOCUMENTOS, VerticaisManager } from "../VerticaisManager";
import { ComponentesVerticais } from "./ComponentesVerticais";
import { DocsVerticais } from "./DocsVerticais";
import { NOME_CLIENTE_MAX_LENGTH, POTENCIA_MINIMA_ENGENHARIA, POTENCIA_MINIMA_VERTICAL, TIPO_SERVICO_REVENDA } from "src/components/projetos/constants";
import { ServicoCodeModal } from "src/components/projetos/containers/ServicoCodeModal";
import { validacaoValorServicoMinimo } from "src/components/projetos/utils/validarValorServicoMinimo";
import { PermissionUtil } from "src/framework/commons/PermissionUtil";
import { JustificativaValorServico } from "src/components/projetos/containers/InputsSection/containers/InputJustificativaValorServico";
import { mostrarAvisoServicoRemovido } from "src/components/projetos/utils/mostrarAvisoServicoRemovido";
import { removeServicoCamposProjeto } from "src/components/projetos/utils/removeServicoCamposProjeto";
import { Upload } from "src/types";
import { Componente, ID_INVERSOR, ID_MICROINVERSOR, ID_MODULO } from "src/components/componentes/types";
import { DEFAULT_VALUES } from "src/components/componentes/forms/BaseForm";
import { InputInfo } from "src/framework/components/forms/inputs/InputInfo/InputInfo";
import { InputText } from "src/framework/components/forms/inputs/InputText";
import { InputComboBoxList } from "src/framework/components/forms/inputs/InputComboBoxList";
import { InputDecimal3 } from "src/framework/components/forms/inputs/InputDecimal3";
import { CPFCNPJMask } from "src/framework/components/forms/masks/CPFCNPJMask";
import { DecimalUtil } from "src/framework/commons/DecimalUtils";
import { ComponentUtil } from "src/framework/commons/ComponentUtil";
import { Formater, TypeRecords } from "src/framework/commons/Formater";

export type ISaveVerticaisFunction = (verticais: Verticais, finalizar?: boolean) => void;
const projetosProvider = new ProjetosProvider();

export interface VerticaisFormProperties extends BaseFormProperties<Verticais, ISaveVerticaisFunction> {
    distribuidores: Conta[];
    revendas: Conta[];
    gruposEstrutura: GrupoEstrutura[];
    ev: Conta[];
    engenheiros: Conta[];
    cidades: Cidade[];
    componentesCache: Componente[];
    readOnly: boolean;
    previousTab?: string;
    onFinalizar?: (projeto: Verticais) => void;
    updateComponentesCache: (componentes: Componente[]) => void;
}

type ListaDocumentos = {
    proposta?: Upload,
    componentes?: Upload,
    comissoes: any[],
    descontos: any[],
}

const TIPO_REVENDA = "revenda"
const TIPO_TURNKEY = "intelbras"

const TIPO_SERVICO = [
    { text: "Nenhum", value: "" },
    { text: "Revenda", value: TIPO_REVENDA },
    { text: "Turnkey", value: TIPO_TURNKEY },
]

const DEFAULT_CIDADE: Cidade = {
    cidade_codigo: null,
    estado_id: null,
    id: 0,
    nome: ""
}

const DEFAULT_CONTAS: Conta = {
    id: 0,
    nome: "",
    auto_classificar_conta: false,
    estado_id: "",
    data_ativacao: "",
    tipo_conta_id: 0
}

const DEFAULT_EXTRAINFO: VerticaisExtra = {
    area_total: 0,
    peso_gerador: 0,
    peso_telhado: 0,
    potencia_gerador: 0,
    valor: 0,
    potencia_inversor: 0,
    valor_servico: 0,
    valor_servico_pis_cofins: 0
}

const EMAIL_PROPOSTA = "email_proposta"

export type VersaoRevisaoValidate = {
    proposta: string | null;
    componentes: string | null;
}

const VerticaisForm: FC<VerticaisFormProperties> = ({
    item,
    distribuidores,
    revendas,
    gruposEstrutura,
    ev,
    engenheiros,
    cidades,
    componentesCache,
    onExit,
    onSave,
    onFinalizar,
    readOnly = false,
    previousTab,
}) => {
    const grupoEstruturaState = useObservable(grupoEstrutura$);
    const permissoes = PermissionUtil.getPermissions();

    const manager: VerticaisManager = new VerticaisManager(VerticaisManager.paths, api, apiNoLoading)
    const [formState, setFormState] = useState<any>(DEFAULT_VERTICAIS);
    const [cidadeState, setCidadeState] = useState<Cidade | null>(DEFAULT_CIDADE);
    const [evState, setEvState] = useState<Conta | null>(DEFAULT_CONTAS);
    const [revendaState, setRevendaState] = useState<Conta | null>(DEFAULT_CONTAS);
    const [distribuidorState, setDistribuidorState] = useState<Conta | null>(DEFAULT_CONTAS);
    const [analistaState, setAnalistaState] = useState<Conta | null>(DEFAULT_CONTAS);
    const [tab, setTab] = useState<string>(TAB_DOCUMENTOS)
    const [mainTab, setMainTab] = useState<string>("projeto")
    const [loadingComponentes, setLoadingComponentes] = useState<boolean>(false);
    const [disableSave, setDisableSave] = useState<boolean>(false);
    const [onCalcLoading, setOnCalcLoading] = useState<boolean>(false);
    const [errorValorServico, setErrorValorServico] = useState<boolean>(false);
    const [errorEv, setErrorEv] = useState<boolean>(false);
    const [tipoServico] = useState<string>("");
    const [extraInfo, setExtraInfo] = useState<VerticaisExtra>(DEFAULT_EXTRAINFO);
    const [anexosUpload, setAnexosUpload] = useState<Anexo[]>([]);
    const estadoListState = useObservable(estados$);
    const cidadeListState = useObservable(cidades$);
    const [estadoSelecionado, setEstadoSelecionado] = useState<string>("");
    const [estadoState, setEstadoState] = useState<Estado | null>(null);
    const [errorState, setErrorState] = useState<string[]>([]);
    const [solicitacaoState, setSolicitacaoState] = useState<any>(undefined)
    const [documentos, setDocumentos] = useState<ListaDocumentos>({
        componentes: undefined,
        proposta: undefined,
        comissoes: [],
        descontos: [],
    });
    const [historicoState, setHistoricoState] = useState([]);
    const [estruturas, setEstruturas] = useState<string[]>([]);
    const [valorMinimoServico, setValorMinimoServico] = useState(0)
    const [errorJustificativa, setErrorJustificativa] = useState(false);

    const tipoServicoOptions = useMemo(()=>{
        return TIPO_SERVICO.map(item => {
            if (item.value === TIPO_SERVICO_REVENDA) return { ...item, disabled: revendaState && !revendaState?.segmentos_servico?.includes("on")}
            return item;
        })
    },[revendaState])

    const buildCalcular = async (componentes: ComponenteProjeto[] = [], projeto: any): Promise<boolean> => {
        const componentesAtributos: any = {};
        prepareCalcular(componentes.map((c) => c.componente_id), projeto as Verticais, componentesAtributos);

        const servico: any = projeto.servico

        const potenciaProjetoInKw = Object.values(componentesAtributos)?.reduce((acc: number, c: any) => {
            // Considera só módulos para calculo da potencia do gerador
            if (c.categoria !== ID_MODULO) return acc;
            return acc + ((c.potencia ? c.potencia / 1000 : 0) * (c.quantidade || 1))
        }, 0)

        const calculo_bdi = (DecimalUtil.toFixed(potenciaProjetoInKw, 2) > POTENCIA_MINIMA_VERTICAL) && (servico === TIPO_SERVICO_REVENDA);

        const projetoCalcular: ProjetoCalcular = {
            servicos: {
                tipo: servico,
                valor: servico === null ? 0 : Number(projeto?.valor_servico || 0),
                calculo_bdi,
            },
            componentes: Object.values(componentesAtributos).map((c: any) => {
                const calcular: any = {
                    quantidade: c.quantidade,
                    valor: c.valor,
                    categoria_componentes_id: c.categoria,
                    peso: c.peso,
                };

                if (Object.keys(c).includes("potencia")) {
                    calcular.potencia = c.potencia;
                }

                if (Object.keys(c).includes("altura")) {
                    calcular.altura = c.altura;
                }

                if (Object.keys(c).includes("largura")) {
                    calcular.largura = c.largura;
                }

                return calcular;
            })
        };

        setOnCalcLoading(true);
        setDisableSave(true);
        try {
            const response: IDataResponse = await manager.calcular(projetoCalcular)
            if (response.statusCode === STATUS_CODE.OK) {

                const extraState: any = { ...extraInfo }
                extraState.area_total = response.data.componentes.area_total;
                extraState.peso_gerador = response.data.componentes.peso_gerador;
                extraState.peso_telhado = response.data.componentes.peso_telhado;
                extraState.potencia_gerador = response.data.componentes.potencia_gerador;
                extraState.potencia_inversor = response.data.componentes.potencia_inversor;
                extraState.valor = response.data.componentes?.valor || 0;
                extraState.valor_servico_pis_cofins = response.data.servicos?.valor_com_pis_cofins || 0;
                setExtraInfo({ ...extraState })
                setDisableSave(false)
                return true
            }

            if (response.statusCode !== STATUS_CODE.OK) {
                setDisableSave(true)
                return false
            }

        } catch (e) {
            return false
        } finally {
            setOnCalcLoading(false);
        }
        return false;
    }

    const calcularServico = async () => {
        await buildCalcular(formState?.componentes, formState)
    }

    const prepareSave = async (finalizar: boolean): Promise<void> => {
        const state: any = { ...formState };

        if (state?.id === 0) {
            delete state.id
        }
        
        if (state?.id !== undefined && state.id > 0) {
            state["@proposta_atualizada"] = true;
        }

        // Calcula se não estiver atualizado os dados de valores
        if (state?.componentes && state?.componentes?.length && !extraInfo.valor) {
            await buildCalcular(state.componentes, state);

            notifierStore.setNotifier({
                title: "Aviso",
                content: [
                    "Os dados de cálculo (peso, potência e valores) foram atualizados.",
                    "Efetue novamente a ação de salvar o projeto."
                ],
                timeOut: 100_000,
                onClose: () => {
                    notifierStore.setOpen(false);
                }
            })
            notifierStore.setOpen(true);
            return;
        } 

        if ([TIPO_REVENDA, TIPO_TURNKEY].includes(state.servico) && (String(formState?.valor_servico) === '' || String(formState?.valor_servico) === '0' || formState?.valor_servico === 0 || formState?.valor_servico === null)) {
            notifierStore.setNotifier({
                title: "Aviso!!!",
                content: `O campo "Valor serviço líquido" é obrigatório quando houver um "Tipo de serviço"`,
                onClose: () => {
                    notifierStore.setOpen(false);
                },
                timeOut: 2_500
            });
            notifierStore.setOpen(true);
            setErrorValorServico(true);
            return;
        }

        if (state.solicitacao?.unidade_consumidora && anexosUpload?.length === 0) {
            notifierStore.setNotifier({
                title: "Aviso!!!",
                content: "Quando o projeto possui unidade consumidora é obrigatório anexar uma fatura.",
                onClose: () => {
                    notifierStore.setOpen(false);
                },
                timeOut: 2500
            });
            notifierStore.setOpen(true);
            return;
        }

        if (!state.ev_id) {
            notifierStore.setNotifier({
                title: "Aviso!!!",
                content: `O campo "Profissional de Vendas" é obrigatório."`,
                onClose: () => {
                    notifierStore.setOpen(false);
                },
                timeOut: 2500
            });
            notifierStore.setOpen(true);
            setErrorEv(true);
            return;
        }

        if (documentos.componentes || documentos.proposta) {
            if (!Object.keys(state).includes("uploads")) {
                state['uploads'] = [];
            }
            if (documentos.componentes) {
                state.uploads.push(documentos.componentes);
            }
            if (documentos.proposta) {
                state.uploads.push(documentos.proposta);
            }
        }

        state.valor_servico = Number(state.servico === null ? 0 : state.valor_servico);
        state.justificativa_valor_servico = exibirJustificativaValorServico && state?.justificativa_valor_servico ? state?.justificativa_valor_servico?.trim() : null;

        if (state.cpf_cnpj_proposta) {
            state.cpf_cnpj_proposta = state.cpf_cnpj_proposta.replace(/[^A-Za-z0-9]/g, "")
        }

        if (anexosUpload) {
            state.anexos = anexosUpload;
        }

        const potenciaGerador =  Number(extraInfo.potencia_gerador);
        const verticais = !state.tipo || state.tipo?.includes('vertical');
        state.valor_servico_pis_cofins = Number(state.servico === null ? 0 : extraInfo.valor_servico_pis_cofins);
        state.valor = Number(extraInfo.valor);
        state.potencia = potenciaGerador
        state.potencia_inversor = Number(extraInfo.potencia_inversor);
        state.engenharia = potenciaGerador > POTENCIA_MINIMA_ENGENHARIA || verticais;

        // Grupos Estruturas
        if (!state.id && state.disposicoes) {
            const _disposicoes: any = [];
            for (let d of state.disposicoes) {
                _disposicoes.push({
                    grupo_estrutura_id: d.id
                })
            }
            state.disposicoes = _disposicoes;
        }

        delete state.ev
        delete state.distribuidor
        delete state.revenda
        delete state.analista
        delete state.cidade
        delete state.revisoes
        
        if (state.codigo_servico !== undefined) {
            delete state.codigo_servico;
        }

        state.segmento = "vertical_ongrid";
        if (!state.tipo) {
            state.tipo = 'vertical';
        }
        if (finalizar && onFinalizar) {
            onFinalizar(state)
        } else {
            onSave(state);
        }
        return;
    }

    const prepareCalcular = (componentesIds: number[], verticais: Verticais, componentesAtributos: any) => {
        if (verticais.componentes) {
            const cachedComponentes: any[] = componentesCache.filter((c) => componentesIds.includes(Number(c.id)));

            cachedComponentes.forEach((c) => {

                const idxComponente = verticais.componentes?.findIndex((_c) => _c.componente_id === c.id);
                componentesAtributos[String(c.id)] = {
                    modelo: c.modelo,
                    categoria: c.categoria_componentes_id,
                    peso: Number(c.peso),
                };

                if (c?.categoria_componentes_id === ID_MODULO) {
                    let potencia = 0;
                    let altura = 0;
                    let largura = 0;

                    const modulos = cachedComponentes.filter((cached: any) => {
                        return cached.categoria_componentes_id === ID_MODULO;
                    });

                    const idxModulo = modulos.findIndex((componenteCached: any) => {
                        return c?.id === componenteCached.id;
                    });

                    if (idxModulo > -1) {
                        if (modulos[idxModulo]["atributos"]) {
                            potencia = parseFloat(`${modulos[idxModulo]["atributos"]["MODULO_POTENCIA"] || 0}`);
                            altura = parseFloat(`${modulos[idxModulo]["atributos"]["MODULO_ALTURA_CALCULO"] || 0}`);
                            largura = parseFloat(`${modulos[idxModulo]["atributos"]["MODULO_LARGURA_CALCULO"] || 0}`);
                        }
                    }

                    componentesAtributos[String(c.id)].potencia = potencia;
                    componentesAtributos[String(c.id)].altura = altura;
                    componentesAtributos[String(c.id)].largura = largura;
                }

                if ([ID_INVERSOR, ID_MICROINVERSOR].includes(Number(c?.categoria_componentes_id))) {
                    let potencia = 0;
                    const inversores = cachedComponentes.filter((cached: any) => {
                        return [ID_INVERSOR, ID_MICROINVERSOR].includes(Number(cached.categoria_componentes_id));
                    });
                    const idxInversor = inversores.findIndex((componenteCached: any) => {
                        return c?.id === componenteCached.id;
                    });
                    if (idxInversor > -1) {
                        if (inversores[idxInversor]["atributos"]) {
                            potencia = parseFloat(`${inversores[idxInversor]["atributos"]["INVERSOR_POTENCIA_MAXIMA_SAIDA"] || 0}`);
                        }
                    }
                    componentesAtributos[String(c.id)].potencia = potencia;
                }

                if (idxComponente !== undefined && idxComponente > -1 && verticais?.componentes) {
                    componentesAtributos[String(c.id)].valor = Number(verticais?.componentes[idxComponente]?.valor_unitario || 0);
                    componentesAtributos[String(c.id)].quantidade = Number(verticais?.componentes[idxComponente]?.quantidade || 0);
                }

            });

            const servico: any = tipoServico === "" ? null : tipoServico;
            return servico;
        }
    }

    const potenciaProjeto = useMemo(()=>{
        if (!formState) return 0;
        if (!formState.componentes?.length) return formState.potencia || 0;

        const componentesAtributos: any = {};
        prepareCalcular(formState?.componentes.map((c: any) => c.componente_id), formState as Verticais, componentesAtributos);
        return Object.values(componentesAtributos)?.reduce((acc: number, c: any) => {
            if (c.categoria !== ID_MODULO) return acc;
            return acc + ((c.potencia ? c.potencia / 1000 : 0) * (c.quantidade || 1))
        }, 0)
    },[formState])

    useEffect(() => {
        if (Number(potenciaProjeto || 0) > 0) {
            projetosProvider.calcularValorMinimoServico(potenciaProjeto).then((response) => {
                setValorMinimoServico(response.data?.valor_minimo_servico || 0)
            })
        }
    },[potenciaProjeto])

    const getHistorico = async (idProjeto: number): Promise<IDataResponse> => {
        const request: IDataRequest = {
            url: `/projetos/historico/consideracoes/${idProjeto}`,
        }
        return await api.get(request)
    }

    const preLoad = async (): Promise<void> => {
        await getCidades();
        await getEstados();
        await getDistribuidores();
        await getRevendas();
        await getEvs();
        await getAnalistasEngenharia();
    }

    const validate = async (): Promise<boolean> => {
        const _errorState = errorState;
        const messages: string[] = [];

        if (!(formState as Verticais)?.cliente_proposta) {
            messages.push("O campo nome do cliente é obrigatório");
            _errorState.push("cliente_proposta")
        }

        if ((formState as Verticais)?.cliente_proposta && (formState as Verticais)?.cliente_proposta.length > NOME_CLIENTE_MAX_LENGTH) {
            messages.push(`O campo nome do cliente deve ter no máximo ${NOME_CLIENTE_MAX_LENGTH} caracteres`);
            _errorState.push("cliente_proposta")
        }
        
        if (!(formState as Verticais)?.cidade_id) {
            messages.push("O campo cidade é obrigatório");
            _errorState.push("cidade_id")
        }

        if (!(formState as Verticais)?.distribuidor_id) {
            messages.push("O campo distribuidor é obrigatório");
            _errorState.push("distribuidor_id")
        }

        if (!(formState as Verticais)?.ev_id) {
            messages.push(`O campo "Profissional de Vendas" é obrigatório`);
            _errorState.push("ev_id")
        }

        if (!(formState as Verticais)?.email_proposta || !ValidateUtil.isValidEmail(formState?.email_proposta)) {
            messages.push("O campo e-mail é obrigatório");
            _errorState.push("email_proposta")
        }

        if (formState?.servico === TIPO_SERVICO_REVENDA && !formState?.revenda_id) {
            messages.push("É obrigatório informar uma revenda para prosseguir com o tipo de serviço selecionado");
        }

        if ((formState.valor_servico || 0) > 0 && valorMinimoServico > 0 && !validacaoValorServicoMinimo(formState.valor_servico, valorMinimoServico, permissoes)) {
            messages.push(`O valor do serviço deve ser maior ou igual a R$ ${Formater.toString(valorMinimoServico, TypeRecords.CURRENCY)}`);
        }

        if(exibirJustificativaValorServico && !formState?.justificativa_valor_servico){
            messages.push('O campo "Justificativa" é obrigatório quando o valor de serviço líquido for menor que o valor mínimo.');
            setErrorJustificativa(true)
        }else{
            setErrorJustificativa(false)
        }

        if (messages.length > 0) {
            setErrorState([..._errorState])
            notifierStore.setNotifier({
                title: "Aviso",
                content: messages,
                timeOut: 3500,
                onClose: () => {
                    notifierStore.setOpen(false)
                }
            })
            notifierStore.setOpen(true)

            return false;
        }

        return messages.length === 0;
    }

    useEffect(() => {
        (async () => {
            await preLoad();

            if (item?.id && item?.componentes) {
                await buildCalcular(item?.componentes, item).then(()=>{});
            }
        })();
    }, [])


    useEffect(() => {
        (async () => {
            await preLoad();

            const itemCustom = { ...item };
            const extraInfoCustom = { ...extraInfo };

            if (itemCustom && itemCustom?.codigo_venda !== "" && itemCustom?.codigo_venda !== null) {
                const uploadPropostaIdx = itemCustom?.uploads?.findIndex((u: Upload) => {
                    return u.tipo === "proposta"
                })

                const uploadComponentesIdx = itemCustom?.uploads?.findIndex((u: Upload) => {
                    return u.tipo === "componentes"
                })
                setDisableSave(!(uploadPropostaIdx !== undefined && uploadComponentesIdx !== undefined && uploadPropostaIdx > -1 && uploadComponentesIdx > -1) && (formState?.codigo_venda !== "" && formState?.codigo_venda !== null))
            }


            if (itemCustom?.valor_servico_pis_cofins !== undefined || itemCustom?.valor_servico_pis_cofins !== null) {
                extraInfoCustom.valor_servico_pis_cofins = Number(itemCustom?.valor_servico_pis_cofins)
            }

            if (itemCustom?.disposicoes) {
                const disposicoesIds = itemCustom.disposicoes.map((d) => d.grupo_estrutura_id);
                extraInfoCustom.estruturas = gruposEstrutura.filter((g) => {
                    return disposicoesIds.includes(g.id)
                }) || []
                setEstruturas(extraInfoCustom.estruturas.map((s) => s.nome))
            }

            setExtraInfo({ ...extraInfoCustom });
            setCidadeState(itemCustom?.cidade || null);
            setEvState(itemCustom?.ev || null);
            setAnalistaState(itemCustom?.analista || null);
            setDistribuidorState(itemCustom?.distribuidor || null);
            setRevendaState(itemCustom?.revenda || null);
            setAnexosUpload(itemCustom?.anexos || []);

            const idxSolicitacao = limitacoes$.getValue().data?.findIndex((l) => l.id === itemCustom?.solicitacao?.limitacao_projeto_id)
            if (idxSolicitacao > -1) {
                setSolicitacaoState(limitacoes$.getValue().data[idxSolicitacao])
            }

            if (itemCustom?.componentes && itemCustom?.componentes?.length > 0) {
                for (let componenteIdx in itemCustom.componentes) {
                    const ic: any = itemCustom?.componentes[componenteIdx];
                    const _componentesCache: any = componentes$.getValue()?.data || []
                    const componentesCacheIdx = _componentesCache?.findIndex((c: any) => c.id === ic.componente_id);

                    if (componentesCacheIdx > -1) {
                        ic.modelo = _componentesCache[componentesCacheIdx].modelo;
                        itemCustom.componentes[componenteIdx].modelo = ic.modelo;
                    }

                }
            }

            // Geral
            if (itemCustom) {
                // Limpa pois quem controla é o back
                delete itemCustom.etapa_venda;
            }

            if (itemCustom.ev) {
                itemCustom.ev_id = itemCustom.ev.id
            }

            if (itemCustom.cidade) {
                itemCustom.cidade_id = itemCustom.cidade.id
                const _estado: Estado = estadoListState?.data?.find((_e: Estado) => _e?.id === itemCustom.cidade?.estado_id) || estados$.getValue()?.data?.find((_e: Estado) => _e?.id === itemCustom.cidade?.estado_id)
                if (_estado) {
                    setEstadoSelecionado(_estado.id);
                    setEstadoState(_estado)
                }
            }

            if (itemCustom.distribuidor) {
                itemCustom.distribuidor_id = itemCustom.distribuidor.id
            }

            if (itemCustom.revenda) {
                itemCustom.revenda_id = itemCustom.revenda.id
            }

            setFormState(itemCustom);

            if (itemCustom?.id) {
                getHistorico(itemCustom.id).then((response: IDataResponse) => {
                    if (response.statusCode === STATUS_CODE.OK) {
                        setHistoricoState(response.data);
                    } else {
                        setHistoricoState([]);
                    }
                })
            }
        })();

    }, [item]);

    useEffect(()=>{
        if (formState?.servico === TIPO_SERVICO_REVENDA && (formState.codigo_servico || Number(formState?.valor_servico || 0) > 0) && revendaState && !revendaState?.segmentos_servico?.includes("on")) {
            setFormState((old: any) => removeServicoCamposProjeto(old))
            mostrarAvisoServicoRemovido()
        }
    },[formState?.servico, formState?.valor_servico, revendaState])

    useEffect(()=>{
        if(!item.id){
            //limpa campos
            setEstadoState(null);
            setEstadoSelecionado('');
        }
    },[previousTab]);

    const valorMinimoHelperText = useMemo(()=>{
        if (valorMinimoServico <= 0) return ""
        if (validacaoValorServicoMinimo(formState?.valor_servico || 0, valorMinimoServico, permissoes)) return ""
        return <span>Para inserir o valor de serviço na plataforma o valor mínimo tem que ser de {Formater.toString(Number(valorMinimoServico), TypeRecords.CURRENCY)}.</span>
    }, [valorMinimoServico, formState?.valor_servico])

    const exibirJustificativaValorServico = useMemo(() => {
        if (!PermissionUtil.can(PermissionUtil.PERMISSION_PROJETOS_EDITAR_ESPECIAL_SERVICO, permissoes)) return false;
        if (formState?.servico === null) return false;
        
        if (!formState?.valor_servico) return false;
        if (!valorMinimoServico) return false;
    
        const valorServicoProjeto = Number(formState?.valor_servico || 0)
        return valorServicoProjeto < Number(valorMinimoServico || 0);
      },[formState?.valor_servico, formState?.servico, valorMinimoServico])

    return (
        <>
            <TabControl
                key={`form-verticais-main-tab-${formState?.id}`}
                currentTabName={mainTab}
                onChangeTab={(value) => setMainTab(value)}
                indicatorColor="primary"
                textColor="primary"
            >
                <TabContent label="Projeto" name="projeto" visible={true}>
                    <div className="row">
                        <div className="X12" style={{ textAlign: "left", paddingTop: "10px", paddingLeft: "10px" }}>
                            <h4>Dados iniciais</h4>
                        </div>
                    </div>
                    <div className="row">
                        <div className="X12 M2">
                            <InputInfo label="Codigo venda" text={formState?.codigo_venda || "Não capturado"} />
                        </div>
                        <div className="X12 M2">
                            <InputInfo label="Valor" text={Formater.toString(extraInfo?.valor || 0, TypeRecords.CURRENCY)} />
                        </div>
                        <div className="X12 M2">
                            <InputInfo label="Valor serviço com imposto" text={Formater.toString(extraInfo?.valor_servico_pis_cofins || 0, TypeRecords.CURRENCY)} />
                        </div>
                        <div className="X12 M2">
                            <InputInfo label="Potência gerador" text={Formater.toString(extraInfo?.potencia_gerador || 0, TypeRecords.DECIMAL2) + " kW"} />
                        </div>
                        <div className="X12 M2">
                            <InputInfo label="Potência inversor" text={Formater.toString(extraInfo?.potencia_inversor || 0, TypeRecords.DECIMAL2) + " kW"} />
                        </div>
                        <div className="X12 M2">
                            <InputInfo label="Área total" text={Formater.toString(extraInfo?.area_total || 0, TypeRecords.DECIMAL2) + " m²"} />
                        </div>

                        <div className="X12 M2">
                            <InputInfo label="Peso gerador" text={Formater.toString(extraInfo?.peso_gerador || 0, TypeRecords.DECIMAL2) + " Kg"} />
                        </div>

                        <div className="X12 M2">
                            <InputInfo label="Estruturas" text={(estruturas?.join(", ") || "Sem estrutura")} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="X12 M2">
                            <InputText
                                label="Título do projeto"
                                fullWidth
                                disabled={readOnly}
                                defaultValue={""}
                                value={formState?.titulo}
                                onChange={(event: any) => {
                                    if (formState) {
                                        setFormState({ ...formState, titulo: String(event?.target?.value) })
                                    }
                                }}
                                error={errorState.includes("titulo")}
                                onBlur={(event: any) => {
                                    if (event.target.value !== "") {
                                        const _errorState = ListUtil.removeItem(errorState, "titulo")
                                        setErrorState([..._errorState])
                                    }
                                }}
                            />
                        </div>

                        <div className="X12 M2">
                            <InputText
                                label="Nome do cliente"
                                disabled={readOnly}
                                fullWidth
                                maxLength={NOME_CLIENTE_MAX_LENGTH}
                                defaultValue={""}
                                value={formState?.cliente_proposta}
                                onChange={(event: any) => {
                                    if (formState) {
                                        setFormState({ ...formState, cliente_proposta: String(event?.target?.value) })
                                    }
                                }}
                                error={errorState.includes("cliente_proposta")}
                                onBlur={(event: any) => {
                                    if (event.target.value !== "") {

                                        const _errorState = ListUtil.removeItem(errorState, "cliente_proposta")
                                        setErrorState([..._errorState])
                                    }
                                }}
                            />
                        </div>
                        <div className="X12 M2">
                            <InputText
                                label="E-mail"
                                disabled={readOnly}
                                fullWidth
                                defaultValue={""}
                                value={formState?.email_proposta}
                                error={errorState.includes(EMAIL_PROPOSTA)}
                                onChange={(event: any) => {
                                    if (formState) {
                                        setFormState({ ...formState, email_proposta: String(event?.target?.value) })
                                    }
                                }}
                                onBlur={(e: any) => {
                                    let _errorState = [...errorState]
                                    if (e.target.value !== "") {
                                        _errorState = ListUtil.removeItem(_errorState, EMAIL_PROPOSTA)
                                        if (ValidateUtil.isValidEmail(e.target.value)) {
                                            _errorState = ListUtil.removeItem(_errorState, EMAIL_PROPOSTA)
                                        } else {
                                            _errorState = ListUtil.addItem(_errorState, EMAIL_PROPOSTA)
                                        }
                                    }
                                    setErrorState(_errorState)
                                }}

                            />
                        </div>

                        <div className="X12 M2">
                            <InputText
                                label="CPF (opcional)"
                                disabled={readOnly}
                                fullWidth
                                defaultValue={""}
                                value={formState?.cpf_cnpj_proposta || ""}
                                InputProps={{
                                    inputComponent: CPFCNPJMask
                                }}
                                onChange={(event: any) => {
                                    if (formState) {
                                        setFormState({ ...formState, cpf_cnpj_proposta: String(event?.target?.value) })
                                    }
                                }}
                            />
                        </div>

                        <div className="X12 S6 M4 L2">
                            <InputComboBoxList
                                id={`listagem-verticais-estado-cb`}
                                key={`listagem-verticais-estado-cb`}
                                label={"Estado"}
                                textField="nome"
                                valueField="id"
                                options={estadoListState?.data || []}
                                value={estadoState}
                                autoComplete

                                renderOptions={(option: any) => {
                                    return `${option.id} - ${option.nome}`
                                }}
                                renderOptionsLabel={(option: any) => {
                                    return `${option.id} - ${option.nome}`
                                }}
                                onChange={(value: any) => {
                                    const state = { ...formState };
                                    if (value) {
                                        state.cidade = undefined;
                                        state.cidade_id = undefined;
                                        setEstadoState(value)
                                        setEstadoSelecionado(String(value.id))
                                        state.estado_id = value.id;
                                    } else {
                                        setEstadoState(null)
                                        setEstadoSelecionado('')
                                        state.estado_id = null;
                                    }
                                    setFormState({ ...state });
                                }}
                            />
                        </div>
                        <div className="X12 M2">
                            <InputComboBoxList
                                id={`form-verticais-cidade-cb-${formState?.id}`}
                                key={`form-verticais-cidade-cb-${formState?.id}`}
                                options={cidadeListState?.data?.filter((c: Cidade) => c.estado_id === estadoSelecionado) || []}
                                label={"Cidade"}
                                textField="nome"
                                valueField="id"
                                value={cidadeState}
                                disabled={readOnly || estadoSelecionado === ""}
                                autoComplete
                                error={errorState.includes("cidade_id")}
                                renderOptions={(option: any) => {
                                    return `${option.nome}`
                                }}
                                renderOptionsLabel={(option: any) => {
                                    return `${option.nome}`
                                }}
                                onChange={(value: Cidade) => {
                                    const state: any = formState;
                                    if (value === null) {
                                        state.cidade = null
                                        state.cidade_id = null
                                        setCidadeState(null)
                                    } else {
                                        state.cidade = value
                                        state.cidade_id = value.id
                                        setCidadeState({ ...value })
                                    }
                                    setFormState({ ...state });
                                    const _errorState = ListUtil.removeItem(errorState, "cidade_id")
                                    setErrorState([..._errorState])
                                }}
                            />
                        </div>

                        <div className="X12 M2">
                            <InputComboBoxList
                                id={`form-verticais-distribuidor-cb-${formState?.id}`}
                                key={`form-verticais-distribuidor-cb-${formState?.id}`}
                                options={distribuidores}
                                label={"Distribuidor"}
                                disabled={readOnly}
                                value={distribuidorState}
                                textField="nome"
                                valueField="id"
                                error={errorState.includes("distribuidor_id")}
                                renderOptions={(option: Conta) => {
                                    return `${option.nome}-${option.cnpj_cpf}`
                                }}
                                renderOptionsLabel={(option: Conta) => {
                                    return `${option.nome}-${option.cnpj_cpf}`
                                }}
                                onChange={(value: Conta) => {
                                    const state: any = formState;
                                    if (value === null) {
                                        state.distribuidor = null
                                        state.distribuidor_id = null
                                        setDistribuidorState(null)
                                    } else {
                                        state.distribuidor = value
                                        state.distribuidor_id = value.id
                                        setDistribuidorState({ ...value })
                                    }
                                    setFormState({ ...state });
                                    const _errorState = ListUtil.removeItem(errorState, "distribuidor_id")
                                    setErrorState([..._errorState])
                                }}
                            />
                        </div>

                        <div className="X12 M3">

                            <InputComboBoxList
                                id={`form-verticais-revenda-cb-${formState?.id}`}
                                key={`form-verticais-revenda-cb-${formState?.id}`}
                                options={revendas}
                                label={"Revenda"}
                                disabled={readOnly}
                                value={revendaState}
                                textField="nome"
                                valueField="id"
                                renderOptions={(option: Conta) => {
                                    return `${option.nome}-${option.cnpj_cpf}`
                                }}
                                renderOptionsLabel={(option: Conta) => {
                                    return `${option.nome}-${option.cnpj_cpf}`
                                }}
                                onChange={(value: Conta) => {
                                    const state: any = formState;
                                    if (value === null) {
                                        state.revenda = null;
                                        state.revenda_id = null
                                        setRevendaState(null)
                                    } else {
                                        state.revenda = value
                                        state.revenda_id = value.id
                                        setRevendaState(value)
                                    }
                                    setFormState({ ...state });
                                }}
                            />
                        </div>

                        <div className="X12 M3">
                            <InputComboBoxList
                                id={`form-verticais-ev-cb-${formState?.id}`}
                                key={`form-verticais-ev-cb-${formState?.id}`}
                                options={ev}
                                label="Profissional de Vendas"
                                disabled={readOnly}
                                error={errorEv || errorState.includes("ev_id")}
                                value={evState}
                                textField="nome"
                                valueField="id"
                                renderOptions={(option: Conta) => {
                                    return option.nome;
                                }}
                                renderOptionsLabel={(option: Conta) => {
                                    return option.nome;
                                }}
                                onChange={(value: Conta) => {
                                    const state: any = formState;
                                    if (value === null) {
                                        state.ev = null;
                                        state.ev_id = null
                                        setEvState(null)
                                    } else {
                                        setErrorEv(false)
                                        state.ev = value
                                        state.ev_id = value.id
                                        setEvState(value)
                                    }
                                    setFormState({ ...state });
                                    const _errorState = ListUtil.removeItem(errorState, "ev_id")
                                    setErrorState([..._errorState])
                                }}
                            />
                        </div>

                        <div className="X12 M3">
                            <InputComboBoxList
                                id={`form-verticais-analista-cb-${formState?.id}`}
                                key={`form-verticais-analista-cb-${formState?.id}`}
                                options={engenheiros}
                                label="Eng. verticais"
                                value={analistaState}
                                disabled={readOnly}
                                textField="nome"
                                valueField="id"
                                renderOptions={(option: Conta) => {
                                    return option.nome;
                                }}
                                renderOptionsLabel={(option: Conta) => {
                                    return option.nome;
                                }}
                                onChange={(value: Conta) => {
                                    const state: any = formState;
                                    if (value === null) {
                                        state.analista = null;
                                        state.analista_id = null
                                        setAnalistaState(null)
                                    } else {
                                        state.analista = value
                                        state.analista_id = value.id
                                        setAnalistaState(value)
                                    }
                                    setFormState({ ...state });
                                }}
                            />
                        </div>

                        <div className="X6 M1">
                            <InputSelectSimple

                                fullWidth
                                label="Tipo de serviço"
                                list={tipoServicoOptions}
                                disabled={formState?.codigo_venda === "" || readOnly}
                                value={formState ? formState?.servico : ""}
                                onChange={(value) => {
                                    const state: any = { ...formState }
                                    state.servico = value === "" ? null : value
                                    if (value === "") {
                                        state.valor_servico = ""
                                    }
                                    setFormState(state);
                                }}
                                onBlur={() => {
                                    calcularServico();
                                }}
                            />
                        </div>
                        <div className="X6 M2">
                            <InputDecimal3
                                error={errorValorServico}
                                disabled={formState?.codigo_venda === "" || (formState?.servico === null) || readOnly || (formState?.servico === TIPO_SERVICO_REVENDA && !!revendaState && !revendaState?.segmentos_servico?.includes("on"))}
                                key={`form-verticais-valor-servico-decimal2-${formState?.id}`}
                                label="Valor serviço líquido"
                                value={String(formState?.valor_servico)}
                                margin="normal"
                                decimal={2}
                                helperText={valorMinimoHelperText}
                                maxLength={15}
                                prefix={<>R$&nbsp;</>}
                                onFocus={() => {
                                    setErrorValorServico(false)
                                }}
                                onBlur={() => {
                                    calcularServico();
                                }}
                                onChange={(event: any) => {
                                    const state: any = { ...formState };
                                    state.valor_servico = event.target.value
                                    setFormState(state);

                                }}
                            />
                        </div>
                        {exibirJustificativaValorServico && (
                            <div className="X12 M8">
                                <JustificativaValorServico
                                    error={errorJustificativa} 
                                    formState={formState} 
                                    setFormState={(e)=>{
                                        const state: any = { ...formState };
                                        state.justificativa_valor_servico = e.justificativa_valor_servico; 
                                        setFormState(state);
                                    }}
                                />
                            </div>
                        )}
                    </div>
                    <div className="row">
                        {formState?.codigo_venda !== "" && formState?.codigo_venda !== null ?
                            <>
                                <div className="X12">
                                    <TabControl
                                        key={`verticais-tab-control-${formState?.id}`}
                                        currentTabName={tab}
                                        onChangeTab={(newTab) => setTab(newTab)}
                                    >
                                        <TabContent label={"Documentos"} visible={true} name={TAB_DOCUMENTOS}>
                                            <DocsVerticais
                                                key={`verticais-docs-${formState?.id}`}

                                                projeto={formState}
                                                proposta={formState?.uploads?.filter((p: any) => p.tipo === "proposta")[0] || null}
                                                componentes={formState?.uploads?.filter((p: any) => p.tipo === "componentes")[0] || null}
                                                disabled={readOnly}
                                                onChange={async (proposta, componentes, informacaoInstrucao) => {
                                                    const state: any = { ...formState }
                                                    const _documentos: any = { ...documentos }

                                                    state["@proposta_atualizada"] = true
                                                    _documentos.proposta = {
                                                        tipo: "proposta",
                                                        url: proposta.path,
                                                        observacao: (informacaoInstrucao || null),
                                                    }

                                                    if (componentes?.estruturas?.length > 0) {
                                                        const novasDisposicoes: Disposicao[] = componentes.estruturas.map((e: any) => {
                                                            return { grupo_estrutura_id: e.id }
                                                        })

                                                        const _d = ComponentUtil.getListPersist(state.disposicoes, novasDisposicoes, "grupo_estrutura_id")

                                                        state.disposicoes = [..._d.data, ..._d.removedData.map((d) => {
                                                            d["@remove"] = true;
                                                            return d
                                                        })]

                                                        setEstruturas(componentes?.estruturas?.map((es: any) => es.nome) || [])
                                                    }

                                                    if (componentes?.componentes?.length > 0) {

                                                        const _componentesNovos = (componentes.componentes.filter((c: Componente) => {
                                                            return Object.keys(c).includes("novo")
                                                        }) || []).map((c: any) => {
                                                            const novo: any = c;
                                                            novo.altura = c.novo.altura;
                                                            novo.comprimento = c.novo.comprimento;
                                                            novo.largura = c.novo.largura;
                                                            novo.peso = c.novo.peso;
                                                            novo.modelo = c.modelo;
                                                            novo.categoria_componentes_id = 200
                                                            delete novo.novo;
                                                            return { ...DEFAULT_VALUES, ...novo }
                                                        });


                                                        for (let componenteIdx in componentes.componentes) {
                                                            const idxNovo = _componentesNovos.findIndex((c: Componente) => c.id === componentes.componentes[componenteIdx].id)
                                                            if (idxNovo > -1) {
                                                                componentes.componentes[componenteIdx] = _componentesNovos[idxNovo];
                                                            }
                                                        }

                                                        state.componentes = componentes.componentes;
                                                    }

                                                    if (componentes?.comissoes) {
                                                        state.auto_comissao = componentes.comissoes.length <= 0
                                                        for (let comissao of componentes.comissoes) {
                                                            if (comissao.tipo === "distribuidor") {
                                                                state.percentual_comissao_distribuidor = comissao.percentual
                                                            }
                                                            if (comissao.tipo === "revenda") {
                                                                state.percentual_comissao_revenda = comissao.percentual
                                                            }
                                                        }
                                                    }
                                                    if (componentes.descontos) {
                                                        const novosDescontos: Desconto[] = componentes.descontos.map((e: Desconto) => {
                                                            return { tipo: e.tipo, percentual: e.percentual }
                                                        })

                                                        const _d = ComponentUtil.getListPersist(state.descontos, novosDescontos, "tipo")

                                                        state.descontos = [..._d.data, ..._d.removedData.map((d) => {
                                                            d["@remove"] = true;
                                                            return d
                                                        })]
                                                    }
                                                    if (componentes?.upload) {
                                                        const componentesUpload = componentes.upload[Object.keys(componentes.upload)[0]]
                                                        _documentos.componentes = {
                                                            tipo: "componentes",
                                                            url: componentesUpload.path
                                                        }
                                                    }

                                                    if (state.componentes.length > 0) {
                                                        setDisableSave(true)
                                                        await buildCalcular(state.componentes, state);
                                                    }

                                                    if (proposta.fullPath) {
                                                        // Indica que foi feito upload de uma proposta
                                                        state["proposta_anexada"] = true    
                                                    }

                                                    setDocumentos(_documentos)
                                                    setFormState(state)
                                                }}
                                            />
                                        </TabContent>
                                        <TabContent label={"Componentes"} visible={true} name={TAB_COMPONENTES}>
                                            <ComponentesVerticais
                                                key={`verticais-componentes-${formState?.id}`}
                                                listaComponentes={formState?.componentes || null}
                                                onLoading={(_loading) => {
                                                    setLoadingComponentes(loadingComponentes);
                                                }}
                                                onChange={(c) => {
                                                    const state: any = { ...formState }
                                                    state.componentes = c;
                                                    setFormState(state);
                                                }}
                                            />
                                        </TabContent>
                                    </TabControl>
                                </div>
                            </> : ""}
                    </div>
                </TabContent>
                <TabContent label="Solicitação" name="sorps" visible={true}>
                    <div className="row">
                        <div className="X12" style={{ textAlign: "left", paddingTop: "10px", paddingLeft: "10px" }}>
                            <h4>Geral</h4>
                        </div>
                    </div>
                    <div className="X12 S6">
                        <InputComboBoxList
                            id={`form-verticais-listagem-limitacoes-${formState?.id}`}
                            key={`form-verticais-listagem-limitacoes-${formState?.id}`}
                            label={"Limitações do projeto"}
                            textField="descricao"
                            valueField="id"
                            options={limitacoes$.getValue()?.data || []}
                            value={solicitacaoState}
                            autoComplete
                            disabled={formState?.id !== 0}
                            onChange={(value: any) => {
                                const state: any = { ...formState }
                                state.solicitacao = { ...state.solicitacao, limitacao_projeto_id: value.id }
                                setFormState(state)
                                setSolicitacaoState(state.solicitacao);
                            }}
                            renderOptions={(option: any) => {
                                return `${option?.descricao}`
                            }}
                            renderOptionsLabel={(option: any) => {
                                return `${option?.descricao}`
                            }}


                        />
                    </div>

                    <div className="X12">
                        <InputText label="Observações" multiline maxRows={7} minRows={7}
                            InputProps={{
                                rows: 7
                            }}
                            fullWidth
                            value={formState?.solicitacao?.limitacao_observacao || ""}
                            disabled={formState?.id !== 0}
                            onChange={(e: any) => {

                                const state: any = { ...formState }
                                state.solicitacao = { ...state.solicitacao, limitacao_observacao: e.target.value }
                                setFormState(state)
                            }}
                        />
                    </div>
                    <div className="X12">
                        {!!formState?.id &&
                            <InputInfo label="Grupos Estruturas" text={formState?.solicitacao?.grupos_estruturas} />
                        }
                        {!formState?.id &&
                            <InputComboBoxList
                                multiple
                                limitTags={3}
                                id={`listagem-verticais-grupo-estrutura-cb`}
                                key={`listagem-verticais-grupo-estrutura-cb`}
                                label={"Grupos estrutura"}
                                textField="nome"
                                valueField="id"
                                options={grupoEstruturaState?.data?.filter((d: any) => d.vertical === true) || []}
                                value={formState?.disposicoes?.filter((d: Disposicao) => !Object.keys(d).includes("@remove")) || []}
                                autoComplete
                                onChange={(value: Disposicao[]) => {
                                    const state: any = { ...formState };
                                    state.disposicoes = value;

                                    const gruposEstruturasName = (value.map((grupo: any) => grupo.nome).join(", ") || null);
                                    state.solicitacao = { ...state.solicitacao, grupos_estruturas: gruposEstruturasName }

                                    setFormState(state)
                                    setSolicitacaoState(state.solicitacao);
                                }}
                                renderOptions={(option: any) => {
                                    return `${option.nome}`
                                }}
                                renderOptionsLabel={(option: any) => {
                                    return `${option.nome}`
                                }}
                            />
                        }
                    </div>
                    <div className="row">
                        <div className="X12" style={{ textAlign: "left", paddingTop: "10px", paddingLeft: "10px" }}>
                            <h4>Anexos</h4>
                        </div>
                        <div className="X12 M6 L3" style={{ display: "flex", alignContent: "flex-start", paddingTop: "4px" }}>
                            <InputSwitch
                                margin="none"
                                label="Possui unidade consumidora?"
                                value={formState?.solicitacao?.unidade_consumidora || false}
                                disabled={formState?.id !== 0}
                                onChangeValue={(value) => {
                                    const state: any = { ...formState }
                                    state.solicitacao = { ...state.solicitacao, unidade_consumidora: value }
                                    setFormState(state)
                                }}
                                style={{ marginTop: "8px" }}
                            />
                        </div>
                        <div className="X12">
                            <AnexosVerticais
                                key={`anexos-verticais-m-${formState?.id}`}
                                formState={formState}
                                anexos={anexosUpload || []}
                                disabled={readOnly}
                                onChange={(uploads: any) => {
                                    const anexosOld = formState?.anexos || []
                                    const r = ComponentUtil.getListPersist(anexosOld, [...(anexosUpload || []), ...uploads], "url")
                                    const _anexos = [...r.data, ...r.removedData.map((rd: Anexo) => {
                                        rd["@remove"] = true
                                        return rd;
                                    })].map((anexo: Anexo) => {
                                        if (!anexo?.id && !anexo?.["@remove"]) {
                                            return {
                                                ...anexo,
                                                "@new": true
                                            };
                                        }
                                        return anexo;
                                    });
                                    setAnexosUpload(_anexos)
                                    const state: any = { ...formState }
                                    state.anexos = _anexos;
                                }}
                                onRemove={(uploads) => {
                                    setAnexosUpload(uploads)
                                }}
                                onCapturaCodigoVenda={(codigoVenda) => {
                                    const state: any = { ...formState }
                                    state.codigo_venda = codigoVenda
                                }}
                            />
                        </div>
                    </div>
                </TabContent>

                <TabContent label="Considerações" name="consideracoes" visible={true}>
                    <div className="row">
                        <div className="X12" style={{ textAlign: "left", paddingTop: "10px", paddingLeft: "10px" }}>
                            <h4>Anexos</h4>
                        </div>
                    </div>
                    <div className="row">
                        <div className="X12">
                            <InputText
                                disabled={readOnly}
                                multiline
                                label="Considerações"
                                fullWidth
                                maxRows={16}
                                minRows={16}
                                value={formState?.observacao || ""}
                                InputProps={{
                                    rows: 16
                                }}
                                onChange={(event: any) => {
                                    if (formState) {
                                        setFormState({ ...formState, observacao: String(event?.target?.value) })
                                    }
                                }}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="X12" style={{ textAlign: "left", paddingTop: "10px", paddingLeft: "10px" }}>
                            <h4>Histórico</h4>
                        </div>
                    </div>
                    <div className="row">
                        <div className="X12">
                            <TableContainer>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell width={200}>Data</TableCell>
                                            <TableCell width={180}>Usuário</TableCell>
                                            <TableCell>Considerações</TableCell>
                                            <TableCell></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {historicoState.map((h: any, index: number) => {
                                            return <>
                                                <TableRow key={`verticais-historico-consideracoa-${formState?.id}-${index}`}>
                                                    <TableCell>{Formater.toString(String(h.created_at), TypeRecords.DATE_TIME)}</TableCell>
                                                    <TableCell>{h.usuario}</TableCell>
                                                    <TableCell>{h.observacao}</TableCell>
                                                    <TableCell></TableCell>
                                                </TableRow>
                                            </>
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                    </div>
                </TabContent>

                <TabContent label="Revisões" name="revisoes" visible={true}>
                    <div className="row">
                        <div className="X12" style={{ textAlign: "left", paddingTop: "10px", paddingLeft: "10px" }}>
                            <TableContainer>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>#</TableCell>
                                            <TableCell>Descrição</TableCell>
                                            <TableCell>Data criação</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {formState?.revisoes?.map((r: any, index: number) => {
                                            return <TableRow key={`form-verticais-revisoes-${formState?.id}-${index}`}>
                                                <TableCell>{index + 1}</TableCell>
                                                <TableCell>{r?.descricao?.split("\n\r\n\r")?.map((r: string) => {
                                                    return <>{r}<br /></>
                                                })}</TableCell>
                                                <TableCell>{Formater.toString(r?.data_revisao, TypeRecords.DATE_TIME)}</TableCell>
                                            </TableRow>
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                    </div>
                </TabContent>
            </TabControl>
            <BottomBar>
                {!readOnly ?
                    <>
                        <FullWidthButton
                            disableElevation={true}
                            text={`Enviar p/ pagamento`}
                            disabled={!(item?.situacao === SITUACAO.PENDENTES && item?.etapa_venda === "pre_orcamento") || disableSave /* || hiddeDocumentos || onCalcLoading */}
                            color={"primary"}
                            variant={"outlined"}
                            onClick={async () => {
                                if (!(await validate())) {
                                    return;
                                }
                                prepareSave(true)
                            }}
                        />
                        <Divider orientation="vertical" flexItem />
                    </>
                    : ""}
                <FullWidthButton
                    text={!readOnly ? "Cancelar" : "Fechar"}
                    color={!readOnly ? "secondary" : "primary"}
                    onClick={() => {
                        onExit();
                    }}
                />
                {!readOnly ?
                    <FullWidthButton
                        disableElevation={true}
                        text={"Salvar"}
                        disabled={disableSave || onCalcLoading || errorState.length > 0}
                        color={"primary"}
                        variant={"contained"}
                        onClick={async () => {
                            if (!(await validate())) {
                                return;
                            }
                            return prepareSave(false);
                        }}
                    />
                    : ""}

            </BottomBar>
            <ServicoCodeModal />
        </>
    );
}

export { VerticaisForm }

